module.exports = __webpack_public_path__ + "img/vodacom-cricket-background-mobile.ab9b4e1b.png";